(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    // Find all elements with .detail-class and check each one
  const allDetails = document.querySelectorAll('.detail-class');
  allDetails.forEach((details) => {
    const detailsContent = details.querySelector('.details-content');
    if (detailsContent) {
      // Hide details if details-content is empty
      const hasContent = detailsContent.textContent?.trim().length > 0 || detailsContent.innerHTML.trim().length > 0;
      if (!hasContent) {
        details.style.display = 'none';
      } else {
        details.addEventListener('click', () => {
          detailsContent.style.display = 'block';
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-slide-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const customSlideControls = document.querySelectorAll('custom-slide-controls');
  customSlideControls.forEach(function(customSlideControl) {
    const slideIndex = customSlideControl.closest('slideshow-slide').getAttribute('data-slide-index');
    const controls = customSlideControl.querySelectorAll('.custom-slide-control');
    const prevButton = customSlideControl.querySelector('[ref="prevButton"]');
    const nextButton = customSlideControl.querySelector('[ref="nextButton"]');
    
    // Handle dot controls (exclude arrow buttons)
    const dotControls = customSlideControl.querySelectorAll('.custom-slide-control:not(.custom-slide-controls__arrow)');
    dotControls.forEach((control, index) => {
      if (index.toString() === slideIndex) {
        control.setAttribute('aria-selected', 'true');
        control.classList.add('active');
      } else {
        control.setAttribute('aria-selected', 'false');
        control.classList.remove('active'); 
      }
    });

    // Handle arrow button clicks
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        // Find the slideshow component and trigger previous
        const slideshow = customSlideControl.closest('slideshow-component');
        if (slideshow) {
          const prevButton = slideshow.querySelector('[data-action="previous"]');
          if (prevButton) {
            prevButton.click();
          }
        }
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        // Find the slideshow component and trigger next
        const slideshow = customSlideControl.closest('slideshow-component');
        if (slideshow) {
          const nextButton = slideshow.querySelector('[data-action="next"]');
          if (nextButton) {
            nextButton.click();
          }
        }
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
